/**
 * Builds Redux `metaData` for the estimate-value radio-select modal on worklists.
 */
import { RadioSelectModalMetaData } from "../../../../components/modals/radioSelectModal/radioSelectModal";
import { BOOptionModel } from "../../../../data-model/boOptionModel";

/** Minimal row shape used to resolve the current estimate value for preselection. */
export interface BoStatusModalTableRow {
  id: string;
  boValueWithRadioSelect?: { value?: string };
}

/**
 * Constructs `RadioSelectModalMetaData` for opening the estimate-value radio modal
 * for a given order row (exception-flow urology orgs).
 *
 * @param orderId - PA order id (`order_id` in modal metadata)
 * @param tableData - Current table rows used to read the preselected estimate value
 * @param estimateOptions - Options loaded from org estimate config (Firestore)
 * @returns Metadata consumed by `RadioSelectModal` from `state.modal.metaData`
 */
export const buildBoStatusModalMetaData = (
  orderId: string,
  tableData: BoStatusModalTableRow[],
  estimateOptions: BOOptionModel[] | undefined,
): RadioSelectModalMetaData => {
  const preselectedValue =
    tableData.find((item) => item.id === orderId)?.boValueWithRadioSelect
      ?.value ?? "";

  const options =
    estimateOptions?.map((option) => ({
      label: option.value,
      value: option.value,
    })) ?? [];

  return {
    order_id: orderId,
    title: "Estimate Options",
    description: "Select an estimate option for the order",
    preselectedValue,
    options,
  };
};
